import React, { FC } from 'react';
import { AuthorizationPage } from '../../pages/authorization';

export const AuthorizationTemplate: FC = () => <AuthorizationPage />;
